import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';

const KpiCard = ({ title, value, subtitle, icon: Icon, accent }) => {
  return (
    <Card
      elevation={0}
      sx={{
        height: '100%',
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
        borderLeft: accent ? '4px solid' : undefined,
        borderLeftColor: accent || 'transparent',
      }}
    >
      <CardContent sx={{ pb: '16px !important' }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1 }}>
          <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
          {Icon ? (
            <Box sx={{ color: 'primary.main', opacity: 0.85 }}>
              <Icon fontSize="small" />
            </Box>
          ) : null}
        </Box>
        <Typography variant="h5" component="div" sx={{ mt: 1, fontWeight: 700, letterSpacing: '-0.02em' }}>
          {value}
        </Typography>
        {subtitle ? (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
            {subtitle}
          </Typography>
        ) : null}
      </CardContent>
    </Card>
  );
};

export default KpiCard;
